<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-02 00:12:30
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-28 01:48:32
-->
<template>
  <div class="sysExperView">
    <search-header />

    <div class="supply-content">
      <div class="supply-content-left">
        <img
          v-if="data && data.photo"
          :src="data.photo"
        />
      </div>

      <div class="supply-content-right">
        <div class="title">专家姓名：{{ data && data.name }}</div>
        <div class="sub-title">
          <span>工作年限：{{ data && data.practiceYear }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历&nbsp;： {{data && data.education}}</span>
        </div>
        <div class="content-row">
          <div class="label">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称&nbsp;：</div>
          <div class="data">{{ data && data.technical }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位&nbsp;：{{ data && data.position}}</div>
        </div>
        <div class="content-row">
          <div class="label">工作单位：</div>
          <div class="data">{{ data && data.workUnit }}</div>
        </div>
        <div class="content-row">
          <div class="label">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位&nbsp;：</div>
          <div class="data">{{ data && data.position}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：{{ this.isxian ? data.phone : " 登录后获取" }}</div>
        </div>
         <div class="content-row">
          <div class="label">简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;介&nbsp;：</div>
          <div class="data">{{ data && data.introduction}}</div>
        </div>

        <a-button class="buy-btn" type="primary" @click="handleAdd">{{
          "发起咨询"
        }}</a-button>
      
      </div>
    </div>
    <div class="content-detail" style="max-width: 1280px">
      <p class="title_top">
        <span class="line"></span>
        <span class="step_title">咨询列表</span>
      </p>
      <div class="result-list">
        <div
          class="result-item"
          v-for="item in list"
          @click="
            () =>
              $router.push({
                path: '/consultingDetail',
                query: { id: item.id, title: item.content, user: item.name },
              })
          "
          :key="item.id"
        >
          <div class="result-info">
            <div class="result-info-title">{{ item.content }}</div>
            <div class="result-info-content">
              <span style="color: #959292">{{ item.type }}</span>
            </div>
            <div class="result-info-link">发布人：{{ item.name }} ({{ item.type }})</div>
          </div>
          <div class="result-time">
            <span>发布时间：{{ item.createTime }}</span>
          </div>
        </div>
      </div>
    </div>

  <a-modal title="发起咨询" :visible="visible" :confirm-loading="confirmLoading" :maskClosable="false" @ok="handleOk" @cancel="visible = false"  okText="确定" cancelText="取消">
      <a-form-model v-model="form">
        <a-form-model-item label="咨询内容">
          <a-textarea v-model="form.content" maxLength="50" placeholder="请输入最多500个字咨询内容" style="width:500px;height:200px;"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 发起咨询弹出框 -->
  </div>
</template>
<script>


import request from "../util/request";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  
  name: "sysExperView",
  data() {
    return {
      isxian: false,
      locale,
      data: {},
      single: {},
      paraId: "",

      title: "",
      visible: false,
      visibleTransfer: false,
      visibleDesign: false,
      confirmLoading: false,
      form: {},
      formTransfer: {},
      formDesign: {}, 
      beConsulted: {},
      mode: "date",

      inputVisible: false,
      inputValue: "",
      type: [],
      org: [],
      industry: [],
      sysExpert: [],
      singlepage: [],
      list: [],
      visibleZ: false,
      formZ: {},
    };
  },
  props: ["userInfo"],
  mounted() {
    const userInfo = localStorage.getItem("userInfo");

    if (userInfo) {
      this.isxian = true;
    }
    let id = this.$route.query.id;
    console.log(id);
    this.beConsulted = id;
    this.queryList();
    this.quertDetail(id);
  },
  methods: {
   queryList() {
      request({
        url: "/api/client/common/consulting/list",
        method: "get",
        params: { page: 1, pageSize: 999999 ,beConsulted:this.beConsulted},
      }).then((res) => {
        if (res.code == "200") {
          this.list = res.data.records;
        }
      });
    },
    quertDetail(id) {
      request({
        url: "/api/client/common/sysExpert/" + id,
        method: "get",
      }).then((res) => {
        this.data = res.data;
      });
    },
  
    handleClose(removedTag) {
      let tags = this.formTransfer.applyProject;
      tags = tags.filter((tag) => tag !== removedTag);
      this.formTransfer.applyProject = tags;
    },

     handleAdd() {
      let token = localStorage.getItem("token");
      console.log(token);
      if (token == null) {
        this.$router.push({ path: "/login", query: { url: location.hash } });
      }
      this.title = "发起咨询";
      this.form = {};
      this.visible = true;
    },
    handleOk() {
        this.form.beConsulted = this.beConsulted;
         if(typeof this.form.content=="undefined" ||  this.form.content==null ||  this.form.content  ==""){
        this.$message.error("咨询内容不能为空");
      return false;
      }
        request({
          url: "/api/client/common/consulting/",
          method: "post",
          params: this.form,
        }).then((res) => {
          if (res.code == "200") {
               this.$message.success("提交成功，商家已收到您的咨询信息，请注意在个人中心追踪您的咨询信息");
            this.visible = false;
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.formTransfer.applyProject;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      this.$set(this.formTransfer, "applyProject", tags);
      Object.assign(this, {
        inputVisible: false,
        inputValue: "",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.supply-content {
  width: 1280px;
  background: #fff;
  margin: 20px auto;
  display: flex;
  .supply-content-left {
    width: 390px;
    img {
      margin: 20px;
      width: 350px;
      height: 350px;
      object-fit: contain;
    }
  }
  .supply-content-right {
    padding: 20px 0;
    flex: 1;
    .title {
      height: 60px;
      line-height: 30px;
      vertical-align: middle;
      font-size: 20px;
      color: #222;
    }
    .sub-title {
      text-align: left;
      vertical-align: middle;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }
    .content-row {
      display: flex;
      align-items: center;
      height: 40px;

    }
    .buy-btn {
      margin: 40px;
      font-size: 16px;
    }
  }
}
.content-detail {
  background: #fff;
  margin: 0 auto;
  .title_top {
    width: 100%;
    height: 34px;
    text-align: left;
    background: #e9f0f8;
    .line {
      height: 16px;
      line-height: 34px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 15px;
      border-left: 4px solid #4790ff;
    }
    .step_title {
      font-size: 18px;
      color: #333;
      font-weight: 700;
      text-align: left;
      line-height: 34px;
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .row {
    display: flex;
    ul > li {
      line-height: 40px;
      font-size: 15px;
      color: #666;
    }
    div {
      flex: 1;
    }
  }
}
ul {
  list-style: none;
}

.result-list {
  background: #fff;
  .result-item { padding:20px;
    align-items: center;
    display: flex;
    height: 200px;
    border-bottom: 2px solid #f2f2f2;
    .avatar {
      width: 220px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .result-info {
      margin-left: 20px;
      width: 600px;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .result-info-title {
        color: #959292;
        font-size: 18px;
        font-weight: bold;
      }
      .result-info-link {
        color: #140a0aa9;
      }
    }
    .result-time {
      color: #999;
    }
  }
}
</style>
